import { createBrowserHistory } from 'history';

const history = createBrowserHistory({
  basename: process.env.NODE_ENV === 'production' ? '/web' : '/web'
});

export default history;
